import { Alert } from '@/components/common/Alert';
import { Notify } from '@/components/common/Notification';
import Modal from '@/components/common/modal';
import { Authenticator } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import '../styles/globals.css';
import { AvanciAdvertisement } from '@/components/common/avanci-advertisement';

const amplifyConfig = {
  ssr: true,
  Auth: {
    region: process.env.NEXT_PUBLIC_AWS_COGNITO_REGION,
    userPoolId: process.env.NEXT_PUBLIC_AWS_USER_POOLS_ID,
    userPoolWebClientId: process.env.NEXT_PUBLIC_AWS_USER_POOLS_WEB_CLIENT_ID,
    mandatorySignIn: false,
    oauth: {},
    aws_cognito_username_attributes: ['EMAIL'],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: [],
    aws_cognito_mfa_configuration: 'OFF',
    aws_cognito_mfa_types: [],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: ['REQUIRES_LOWERCASE', 'REQUIRES_NUMBERS'],
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    cookieStorage: {
      domain: process.env.NODE_ENV === 'development' ? 'localhost' : '.avanci.ai',
      secure: process.env.NODE_ENV !== 'development',
      path: '/',
      expires: 2,
      sameSite: process.env.NODE_ENV === 'development' ? 'lax' : 'strict',
    },
  },
};

Amplify.configure(amplifyConfig);

function MyApp({ Component, pageProps }) {
  const getLayout = Component.getLayout ?? ((page) => page);

  return (
    <>
      <Authenticator.Provider>
        <Notify />
        <Modal />
        <Alert />
        <AvanciAdvertisement />
        {getLayout(<Component {...pageProps} />)}
      </Authenticator.Provider>
    </>
  );
}

export default MyApp;
